import AiHomeContainer from "@/components/ai/ai-home-container";
import AiSideBar from "@/components/ai/ai-side-bar";

const AiHomePage = () => {
  return (
    <div
      className="flex h-[calc(100vh-70px)] overflow-hidden"
      style={{
        background:
          "radial-gradient(50.44% 50.44% at 50.87% 49.25%, #C7EFEB 0%, #FFF 100%)",
      }}
    >
      <AiSideBar />
      <AiHomeContainer />
    </div>
  );
};

export default AiHomePage;
